import "core-js/modules/es.object.to-string";
import "vant/es/toast/style";
import _Toast from "vant/es/toast";
import store from '@/store/index';

/**
 * 发起微信支付
 *
 * @param {object} params
 *  - timeStamp
 *  - nonceStr
 *  - package
 *  - signType
 *  - paySign
 *
 * @return {Promise} {status<Enum(success,error,cancel)>, result, message}
 */
export function chooseWXPay(params) {
  return new Promise(function (resolve, reject) {
    if (!store.state.jssdk || !store.state.jssdk.jssdkReady) {
      _Toast("\u5FAE\u4FE1\u652F\u4ED8\u52A0\u8F7D\u5931\u8D25");

      return;
    }

    wx.chooseWXPay({
      timestamp: params.timestamp,
      nonceStr: params.nonceStr,
      "package": params["package"],
      signType: params.signType,
      paySign: params.paySign,
      // 支付成功后的回调函数
      success: function success(res) {
        if (res.errMsg === 'chooseWXPay:ok') {
          resolve({
            status: 'success'
          });
        } else if (res.errMsg === 'chooseWXPay:cancel') {
          resolve({
            status: 'cancel'
          });
        } else {
          resolve({
            status: 'error',
            result: res.errMsg,
            message: res.errMsg
          });
        }
      },
      cancel: function cancel() {
        resolve({
          status: 'cancel'
        });
      },
      fail: function fail(res) {
        resolve({
          status: 'error',
          result: res.errMsg,
          message: res.errMsg
        });
      }
    });
  });
}